import styled from '@emotion/styled';
import { themeGet } from '@lightspeed/flame/Core';

// A variant of the Badge exists in the latest version of Flame but it
// affects other systems in R-Series.  Instead, we duplicate the styling
// for the warning variant:
//
// https://github.com/lightspeed/flame/blob/next/packages/flame/src/Badge/next/Badge.tsx
export const DaysLeft = styled.span`
  display: inline-flex;
  color: ${themeGet('colors.textHeading')};
  padding-left: ${themeGet('space.2')};
  padding-right: ${themeGet('space.2')};
  line-height: ${themeGet('lineHeights.4')};
  background-color: ${themeGet('colors.orange-200')};
  border-color: ${themeGet('colors.orange-300')};
  border-width: 1px;
  border-style: solid;
  border-radius: 28px;
  fontsize: ${themeGet('fontSizes.text-s')};
  fontweight: ${themeGet('fontWeights.bold')};
  text-align: center;
`;
